import * as Yup from "yup";

const NATIONALITY = {
  DOMESTIC: "domestic",
  FOREIGNER: "foreigner",
};

export const initialValues = {
  email: null,
  telephoneNumber: null,
  personalEmail: null,
  mobileNumber: null,
  registerAddress: null,
  registerProvinceId: null,
  registerDistrictId: null,
  registerSubDistrictId: null,
  registerZipCode: null,
  registerAddressEn: NATIONALITY.DOMESTIC,
  registerProvinceId: null,
  registerDistrictId: null,
  registerSubDistrictId: null,
  registerZipCode: null,
  address: null,
  provinceId: null,
  districtId: null,
  subDistrictId: null,
  zipCode: null,
  addressEn: NATIONALITY.DOMESTIC,
  provinceId: null,
  districtId: null,
  subDistrictId: null,
  zipCode: null,
  // maritalStatusId: null,
  // militaryStatusId: null,
  // bloodGroupId: null,
  // weight: null,
  // height: null,
  // remark: null,
};

const EmployeeInfoContactSchema = Yup.object().shape({
  email: Yup.string().required("Please enter email."),
  mobileNumber: Yup.string().required("Please enter mobileNumber."),
  registerAddress: Yup.string().required("Please enter address."),
  registerProvinceId: Yup.string().required("Please select province."),
  registerDistrictId: Yup.string().required("Please select district."),
  registerSubDistrictId: Yup.string().required("Please select sub district."),
  registerZipCode: Yup.string().required("Please select zip code."),
  registerAddressEn: Yup.string().required("Please enter address."),
  registerProvinceId: Yup.string().required("Please select province."),
  registerDistrictId: Yup.string().required("Please select district."),
  registerSubDistrictId: Yup.string().required("Please select sub district."),
  registerZipCode: Yup.string().required("Please select zip code."),

  // address: Yup.string().required("Please enter address."),
  // provinceId: Yup.string().required("Please select province."),
  // districtId: Yup.string().required("Please select district."),
  // subDistrictId: Yup.string().required("Please select sub district."),
  // zipCode: Yup.string().required("Please select zip code."),
  // addressEn: Yup.string().required("Please enter address."),
  // provinceId: Yup.string().required("Please select province."),
  // districtId: Yup.string().required("Please select district."),
  // subDistrictId: Yup.string().required("Please select sub district."),
  // zipCode: Yup.string().required("Please select zip code."),
  // titleId: Yup.string().required("Please select title."),
  // name: Yup.string().required("Please enter name."),
  // surName: Yup.string().required("Please enter surname."),
  // nameEn: Yup.string().required("Please enter name."),
  // surNameEn: Yup.string().required("Please enter surname."),
  // dateOfBirth: Yup.string().required("Please select date of birth."),
  // genderId: Yup.string().required("Please select gender"),
  // employeeNationality: Yup.string().required("Please select nationality."),
  // // raceId: Yup.string().required("Please select race."),
  // // nationalityId: Yup.string().required("Please select nationality."),
  // religionId: Yup.string().required("Please select religion."),
  // maritalStatusId: Yup.string().required("Please select marital status."),
  // militaryStatusId: Yup.string().required("Please select military status."),
  // bloodGroupId: Yup.string().required("Please blood group."),
  // weight: Yup.string().required("Please enter weight."),
  // height: Yup.string().required("Please enter height."),
});

export default EmployeeInfoContactSchema;
